export default "__VITE_ASSET__93c29650__"